import api from '@/utils/api';

/**
 * delete company option
 *
 * @param {string} companyId - The company id
 * @param {string[]} ids - The option id
 * @returns {Promise} The promise object of the api call
 */
const deleteBulkCompanyOptionApi = (companyId, ids) =>
  api.post(`company/${companyId}/option/bulk-delete`, ids);

export default deleteBulkCompanyOptionApi;
